import type {
  CoverArtPresignBody,
  EventIdeaPresignResponse,
} from '@@/types/api';
import { useApi } from './use-api';

/**
 * Cover-art presign for an Event Idea.
 *
 * Mirrors `useUploadsApi` for native events, with the subject carried by the
 * PATH rather than the body — the `useRegistrationTypesApi(eventId)` precedent.
 * The ordering is the opposite of the native flow: the native presign CREATES a
 * draft event, whereas an idea must ALREADY exist (and be `active`, and be
 * owned by the caller) before it can be presigned against.
 *
 * The request body is the shared `CoverArtPresignBody`; only the response's
 * subject key differs (`event_idea_id` vs `event_id`).
 */
export function useEventIdeaUploadsApi(ideaId: string) {
  const { post } = useApi(`/api/v1/event-ideas/${ideaId}/uploads`);

  return {
    getPresignedUrl: (input: CoverArtPresignBody) =>
      post<EventIdeaPresignResponse>('/presigned-url', { body: input }),
  };
}
